import React from "react";

// 404 component
const FourOhFour = () => <p className="four-oh-four">Nothing found</p>;

export default FourOhFour;